import React, { useState, useRef, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import "./Documents.scss";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { BiUpload } from "react-icons/bi";
import { ScaleLoader } from "react-spinners";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import FolderCreate from "./FolderCreate/FolderCreate";
import DmsService from "../../../core/service/DmsService";
import FolderBreadcrumb from "./FolderBreadcrumb/FolderBreadcrumb";
import RiskConfigService from "../../../core/service/RiskConfigService";
import Folder from "./Folder/Folder";
import File from "./File/File";
import FileService from "../../../core/service/FileService";
import nodataimg from "../../../images/nodatafound.png";

import Share_folerAdd from "../../../images/Share_foler_Add.svg";
import SupplierService from "../../../core/service/SupplierService";
import DocumentModal from "../../../components/DocumentModal/DocumentModal";

export const ROOT_FOLDER = { name: "Folders", id: null };

function Documents({ t }) {
  const [showNewFolder, setShowNewFolder] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [show, setShow] = useState(false);
  const [directory, setDirectory] = useState([]);

  const [parentId, setParentId] = useState("");
  const [currentFolder, setCurrentFolder] = useState([
    { id: "0", name: "Documents" },
  ]);
  const [selectedFile, setSelectedFile] = useState("");
  const [loading, setLoading] = useState(false);
  const [supplierList, setSupplierList] = useState([]);
  const [selSupplier, setSelSupplier] = useState("");
  const [showAllNew, setShowAllNew] = useState(false);
  const [modalObj, setModalObj] = useState({});
  const [regulation, setRegulation] = useState("");
  const hiddenFileInput = useRef(null);
  const folderId = null;
  const state = useLocation();
  var data = JSON.parse(localStorage.getItem("authority"));
  const company = data.profile.company.id;
  const color = "#383cc1";
  useEffect(() => {
    document.addEventListener("click", handleClickOuter);
    return () => {
      document.removeEventListener("click", handleClickOuter);
    };
  });

  useEffect(() => {
    if (company) {
      if (folderId === null) {
        getRootFolders(company);
      } else {
        getSubFolders(folderId);
      }
      data.roles.includes("SUBSCRIBER_ADMIN") && getSuppliers();
    } else {
      getRegulations();
    }
  }, [folderId]);

  const handleClickOuter = useCallback(() => setShowInfo(false), [showInfo]);

  //const handleCheckbox = () => setShowCheck(!showCheck);
  const getRootFolders = (company) => {
    DmsService.getRootFolders(company)
      .then((response) => {
        setDirectory([...response.data]);
      })
      .catch((error) => {});
    setDirectory([]);
  };
  const getSubFolders = (folderId) => {
    DmsService.getFolderContent(folderId)
      .then((response) => {
        setDirectory([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      });
    setDirectory([]);
  };
  const callbackDocument = (id, folderName, reg) => {
    getSubFolders(id);
    setParentId(id);
    /*
     * create reagulation object only if callback reg value is not null
     * and index of breadcrumb variable is 1 (ie, the regulation)
     */
    reg &&
      currentFolder.length <= 1 &&
      setRegulation({ id: reg, name: folderName, docId: id });
    let obj = { id: id, name: folderName };
    setCurrentFolder([...currentFolder, obj]);
  };
  const getRegulations = () => {
    RiskConfigService.getRegulations()
      .then((response) => {
        setDirectory([...response.data]);
      })
      .catch((error) => {});
  };
  const callbackClose = () => {
    setShowNewFolder(false);
    getSubFolders(parentId);
  };
  const callbackBreadCrumb = (index, folderId) => {
    index === 0 ? getRootFolders(company) : getSubFolders(folderId);

    let data = [...currentFolder];
    let parent = index > 0 ? data[index - 1].id : "";
    setParentId(parent);
    data.length = index + 1;
    setCurrentFolder(data);
  };
  const callbackDeleteDocument = (deleteItem) => {
    setShow(false);
    if (deleteItem.canEdit) {
      DmsService.deleteDocument(deleteItem.id)
        .then((response) => {
          getSubFolders(parentId);
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
        });
    }
  };
  const handleFileClick = (event) => {
    hiddenFileInput.current.click();
  };
  //file upload
  const handleFileSelect = (event) => {
    setLoading(true);
    const fileUploaded = event.target.files[0];
    setSelectedFile(fileUploaded);
    const formData = new FormData();
    formData.append("file", fileUploaded);
    setLoading(true);
    FileService.uplaodFile(formData, parentId)
      .then((response) => {
        getSubFolders(parentId);
      })
      .catch((error) => {})
      .finally(() => {
        setLoading(false);
      });
  };
  const callbackRename = (id) => {
    getSubFolders(id);
    setParentId(id);
  };
  const getSuppliers = () => {
    SupplierService.listAllSuppliers(company)
      .then((response) => {
        let options = response.data.filter(
          (item) => item.invitationStatus === "ONBOARDED"
        );
        setSupplierList([...options]);
      })
      .catch((error) => {});
  };
  const handleShareFolderAdd = () => {
    setShowAllNew(true);
    let obj = {
      isShow: true,
      action: "Create",
      parent: parentId,
      regulation: regulation,
    };
    setModalObj(obj);
  };
  const callbackDocumentModal = (obj) => {
    if (obj.isClose) {
      setShowAllNew(false);
    }
  };
  const handleSupplier = (selected) => {
    setDirectory([]);
    if (selected.length === 0) {
      getSubFolders(regulation.docId);
      setParentId(regulation.docId);
    } else if (selected[0]) {
      setSelSupplier(selected[0]?.companyId);
      handleSupplier(selected[0]?.companyId);
      DmsService.getDocumentsSharedWithSupplier(
        selected[0]?.companyId,
        regulation.docId
      )
        .then((response) => {
          setDirectory([...response.data]);
        })
        .catch((error) => {});
    }
    setCurrentFolder(currentFolder.slice(0, 2));
  };

  return (
    <>
      {loading && (
        <div className="loader-custom">
          <ScaleLoader color={color} loading={true} size={25} />
        </div>
      )}
      <div className="DMSFiles">
        <div className={`List_header${currentFolder.length>1 ? " border-bottom" : ""}`}>
          {currentFolder.length > 1 && (
            <FolderBreadcrumb
              currentFolder={currentFolder}
              callbackBreadCrumb={callbackBreadCrumb}
            />
          )}

          <div className="List_sorts_menu">
            <ul>
              {parentId && (
                <li>
                  <button className="Icon_btn" onClick={handleShareFolderAdd}>
                    <img src={Share_folerAdd} alt={Share_folerAdd} />
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="row m-0 Sub_Menu_listbox">
          {supplierList.length > 0 && parentId && (
            <div className="col-md-6 p-0">
              <div className="d-flex align-items-center">
                <label className="p-2"> {t("SupplierName.label")}</label>
                <div className="p-2">
                  <Typeahead
                    clearButton
                    id="country_op"
                    labelKey={(options) => options.legalName}
                    onChange={handleSupplier}
                    options={supplierList}
                    placeholder={t("Select.label")}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="col-md-6 p-0">
            <div className="List_sorts_menu">
              <ul>
                {parentId && (
                  <li>
                    <input
                      type="file"
                      onChange={handleFileSelect}
                      ref={hiddenFileInput}
                      style={{ display: "none" }}
                    />
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleFileClick}
                    >
                      <BiUpload className="me-1" />
                      {t("Upload.label")}
                    </button>
                  </li>
                )}
                {parentId && (
                  <li>
                    <button
                      type="button"
                      className="btn btn-primary "
                      onClick={() => setShowNewFolder(true)}
                    >
                      {t("NewFolder.label")}
                    </button>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="p-2">
          <div className="DMSFiles_folderBox">
            {directory?.map((doc) =>
              doc.directory === true ? (
                <Folder
                  folder={doc}
                  key={doc.id}
                  callbackFolder={callbackDocument}
                  deleteFolder={callbackDeleteDocument}
                  callbackRename={callbackRename}
                />
              ) : (
                <File
                  file={doc}
                  key={doc.id}
                  callbackFile={callbackDocument}
                  deleteFile={callbackDeleteDocument}
                />
              )
            )}
            {showNewFolder && (
              <FolderCreate
                show={showNewFolder}
                close={callbackClose}
                parentId={parentId}
              />
            )}
          </div>
        </div>
      </div>
      {showAllNew && (
        <DocumentModal
          modalObj={modalObj}
          callbackModal={callbackDocumentModal}
        />
      )}
    </>
  );
}

export default withTranslation()(Documents);
